import api from '@/utils/api';
import {
    GET_LIST_TREATMENT_SESSION,
    GET_TREATMENT_SESSION_BY_CUSTOMER,
    GET_SPECIFIC_TREATMENT_SESSION,
    UPDATE_SPECIFIC_TREATMENT_SESSION,
    CREATE_NEW_TREATMENT_SESSION,
    REMOVE_TREATMENT_SESSION
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListTreatmentSession = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/treatment-sessions', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_TREATMENT_SESSION, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

/**
 * Lấy danh sách Treatment Session theo bộ lọc
 */
export const getTreatmentSessionCustomer = (filter, customer_id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get('/treatment-sessions/customer/' + customer_id, { params: filter })
            .then((res) => {
                dispatch({ type: GET_TREATMENT_SESSION_BY_CUSTOMER, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                // NotificationManager.error(
                //     err.response?.data?.msg || 'Không thể tải danh sách Treatment Session'
                // );
                reject(err);
            });
    });
};

/**
 * Lấy Treatment Session cụ thể theo ID
 */
export const getSpecificTreatmentSession = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/treatment-sessions/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_TREATMENT_SESSION, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết Treatment Session'
                );
                reject(err);
            });
    });
};

/**
 * Tạo mới Treatment Session
 */
export const createTreatmentSession = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .post('/treatment-sessions', data)
            .then((res) => {
                dispatch({ type: CREATE_NEW_TREATMENT_SESSION, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Thêm mới Treatment Session thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Cập nhật Treatment Session
 */
export const updateTreatmentSession = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/treatment-sessions/${id}`, data)
            .then((res) => {
                dispatch({ type: UPDATE_SPECIFIC_TREATMENT_SESSION, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Cập nhật Treatment Session thất bại'
                );
                reject(err);
            });
    });
};

/**
 * Xoá một hoặc nhiều Treatment Session
 */
export const removeTreatmentSession = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .delete('/treatment-sessions', { data: { ids } })
            .then((res) => {
                dispatch({ type: REMOVE_TREATMENT_SESSION, payload: ids });
                NotificationManager.success('Xoá thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Xoá thất bại'
                );
                reject(err);
            });
    });
};


/**
 * Duyệt phiếu điều trị
 */
export const approveTreatmentSession = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/treatment-sessions/approve/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_TREATMENT_SESSION,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã xác nhận phiếu điều trị!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể duyệt phiếu!');
                reject(err);
            });
    });
};

/**
 * Hủy duyệt phiếu điều trị
 */
export const unapproveTreatmentSession = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/treatment-sessions/unapprove/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_TREATMENT_SESSION,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã hủy xác nhận phiếu điều trị!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể hủy duyệt phiếu!');
                reject(err);
            });
    });
};


/**
 * Duyệt nhiều phiếu điều trị
 */
export const approveTreatmentSessionBulk = (ids = []) => dispatch => {
    return new Promise((resolve, reject) => {
        if (!ids.length) {
            NotificationManager.warning('Chưa chọn phiếu điều trị nào!');
            return reject();
        }

        api.put('/treatment-sessions/approve-bulk', { ids })
            .then(res => {
                NotificationManager.success(
                    res.data.msg || `Đã xác nhận ${res.data.data?.approved || 0} phiếu điều trị`
                );

                // Không dispatch UPDATE_SPECIFIC vì là bulk
                // Chỉ cần reload list ở UI
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể xác nhận hàng loạt!'
                );
                reject(err);
            });
    });
};


/**
 * Hủy duyệt nhiều phiếu điều trị
 */
export const unapproveTreatmentSessionBulk = (ids = []) => dispatch => {
    return new Promise((resolve, reject) => {
        if (!ids.length) {
            NotificationManager.warning('Chưa chọn phiếu điều trị nào!');
            return reject();
        }

        api.put('/treatment-sessions/unapprove-bulk', { ids })
            .then(res => {
                NotificationManager.success(
                    res.data.msg || `Đã hủy xác nhận ${res.data.data?.unapproved || 0} phiếu điều trị`
                );

                // Không dispatch reducer item lẻ
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể hủy xác nhận hàng loạt!'
                );
                reject(err);
            });
    });
};


/**
 * Tạo phiếu điều trị trực tiếp cho khách hàng cũ,
 * bỏ qua bước chọn lịch hẹn và tự động sinh lịch hẹn tương ứng;
 * chỉ sử dụng cho các khách chưa có phiếu điều trị.
 * @deprecated Use createTreatmentSession instead
 */
export const createDirectTreatmentSession = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .post('/treatment-sessions/create/direct', data)
            .then((res) => {
                dispatch({ type: CREATE_NEW_TREATMENT_SESSION, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Thêm mới Treatment Session thất bại'
                );
                reject(err);
            });
    });
};